// src/components/DeletePopup.js
import React from "react";
import "../styles/DeletePopup.css";

const DeletePopup = ({ open, onClose, onConfirm, bookTitle }) => {
  if (!open) return null;

  return (
    <div className="delete-popup-overlay">
      <div className="delete-popup-box">
        <h3>Delete Book</h3>
        <p>
          Are you sure you want to delete{" "}
          <strong>{bookTitle || "this book"}</strong>?
        </p>

        <div className="delete-popup-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
